import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, Layout, Loader } from '@flexisaf/flexibull2';
import Theme from 'utils/theme';
import Disconnect from 'assets/images/plug.svg';
import { useHistory, useRouteMatch } from 'react-router';
import {
  getQueryVariable,
  setLocalAccessToken,
  setLocalRefreshToken,
  setLocalUser,
} from 'utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { userLoginSuccess } from 'redux/users/actions';
import request from 'utils/request';
import orgConfig from 'utils/orgConfig';
import urls from 'utils/config';
import { CanFilter } from 'components/CanView';
import { menuItems } from 'routes';
import { selectOrgAliases } from 'redux/configurations/selectors';
import {
  getCanonicalOrgId,
  getPortalSlug,
  migrateAdminStorage,
  setAuthOrganisationId,
  setOrgRoutingKeys,
} from 'utils/portalSlug';

const StyledDiv = styled.div`
  width: 100vh;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin-top: 250px;
  & div {
    width: 45%;
    text-align: center;
  }
`;

const GoogleAuth = () => {
  const [error, setError] = useState(false);
  const { params } = useRouteMatch();
  const history = useHistory();
  const portalSlug = getPortalSlug(params.orgName);
  const dispatch = useDispatch();
  const getAppId = localStorage.getItem('app_redirect');
  const aliases = useSelector(selectOrgAliases);

  const { UMS_BASE_URL } = urls;

  const getUserDetails = async (code, orgId) => {
    const url = `${UMS_BASE_URL}/auth/products/${orgConfig.product}/organisations/${orgId}/transfer`;
    const response = await request({ method: 'post', url, data: { code } });
    if (response.success) {
      dispatch(
        userLoginSuccess({
          ...response.raw.user,
          adminRoles: response.raw.user.roles,
        })
      );
      setLocalAccessToken(response.raw.access_token);
      setLocalRefreshToken(response.raw.refresh_token);
      setLocalUser(
        JSON.stringify({
          ...response.raw.user,
          adminRoles: response.raw.user.roles?.map((role) => ({
            adminLevel: role.admin_level,
            roles: role.role,
          })),
        })
      );
      window.dataLayer.push({
        event: 'login',
        method: 'google',
        orgId: orgId,
        userId: response?.raw?.user?.id,
      });
    }
    return response;
  };

  const getToken = async () => {
    const code = getQueryVariable('transfer_code') || '';
    const canonicalOrgId = getCanonicalOrgId(params.orgName);
    const portalSlug = getPortalSlug(params.orgName);
    if (code) {
      const res = await getUserDetails(code, canonicalOrgId);
      if (res.success) {
        setOrgRoutingKeys(canonicalOrgId, portalSlug);
        setAuthOrganisationId(canonicalOrgId);
        if (params.orgName && params.orgName !== portalSlug) {
          migrateAdminStorage(params.orgName, portalSlug);
        }
        const availableRoutes = CanFilter(menuItems(portalSlug, aliases));
        if (
          getAppId &&
          availableRoutes.find(
            (route) => route?.navlink === `/${portalSlug}/applicants`
          )
        ) {
          history.push(
            `/${portalSlug}/applicants/?applicationId=${getAppId}`
          );
        } else {
          history.push(
            availableRoutes?.[0]?.navlink || `/${portalSlug}/user-profile`
          );
        }
      } else {
        setError(true);
      }
    } else {
      setError(true);
    }
  };

  useEffect(() => {
    getToken();
    // eslint-disable-next-line
  }, []);

  return (
    <Layout
      theme={{
        Theme,
      }}
    >
      <StyledDiv>
        {!error ? (
          <Loader color={'grey'} section size={65} />
        ) : (
          <div>
            <img src={Disconnect} alt="" />
            <h2>User Not Found</h2>
            <p>The user with that email address does not exist or is wrong.</p>
            <Button
              spaceRight
              onClick={() => history.push(`/${portalSlug}/`)}
            >
              Back to login
            </Button>
          </div>
        )}
      </StyledDiv>
    </Layout>
  );
};

export default GoogleAuth;
